<template>
  <v-container class="px-1 pt-0">
    <v-data-table
      v-model="selecaoTabela"
      dense
      :headers="headers"
      :items="list"
      :page.sync="page"
      :items-per-page="20"
      show-select
      hide-default-footer
      class="lotesListTable"
      @toggle-select-all="selecionaTodos"
      @item-selected="selecaoUnica"
      @page-count="pageCount = parseInt($event, 10)"
    >
    <template v-slot:item.selected="{ item }">
        <v-simple-checkbox
          v-model="item.selected"
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.arq_nome="{ item }">
        <v-tooltip v-if="item.complementar==true" bottom open-delay="50" >
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"
              ><v-icon class="pt-0" style="font-size:11px !important" color="primary">fa-asterisk</v-icon></span>
          </template>
          <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Lote complementar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }" >
            <span v-bind="attrs" v-on="on" class="pa-0">
              {{ item.arq_nome }}
            </span>
          </template>
          <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">{{ item.arq_nome }}</span>
        </v-tooltip>
        <br>
              <v-btn 
                v-if="item.etapa != 10 && item.etapa != 25 && item.etapa != 30 && !item.is_editing" 
                @click="getDocument({doc_id: item.doc_id, nome: item.arq_nome})"
                color="primary" 
                class="pa-0 mt-0" 
                x-small 
                text>
                <v-icon class="py-0 pl-0 pr-1" x-small>fa-download</v-icon>
                Lote
              </v-btn>

      </template>
      <template v-slot:item.upload_dt="{ item }">
        {{ item.upload_dt | formatDate }}
      </template>
      <template v-slot:item.etapa="{ item }">
        <div class="d-flex justify-space-between" style="max-width:100%">
          <b style="color:#4A4A4A" class="pt-1 px-0" v-if="item.etapa == 10 && item.proc_trd_tem_erro == 0">Em validação</b>
          <b style="color:#32B88B" class="pt-1 px-0" v-if="item.etapa == 20 && item.proc_trd_tem_erro == 0 && !item.complementar && item.env_op_tem_erro == 0">Prontos <br> para transmissão</b>
          <b style="color:#D0021B" class="pt-1 px-0" v-if="item.etapa <= 20 && (item.proc_trd_tem_erro == 1 || item.env_op_tem_erro == 1)">Erro na <br> validação</b>
          <b style="color:#4A4A4A" class="pt-1 px-0" v-if="(item.etapa == 25 || item.etapa == 30) && !item.complementar">Em transmissão</b>
          <b style="color:#32B88B" class="pt-1 px-0" v-if="item.etapa >= 20 && !item.proc_trd_tem_erro  && item.complementar">Validado</b>
          <b style="color:#4A4A4A" class="pt-1 px-0" v-if="!item.complementar && item.etapa >= 40 && item.etapa < 70 && item.env_op_tem_erro == 0">Aguardando status <br>do protocolo</b> 
          <b :style="item.fl_tratado? 'color:#118aca':'color:#D0021B'" class="pt-1 px-0" v-if="!item.complementar && item.etapa >= 40 && item.etapa < 70 && item.env_op_tem_erro == 1">Erro ao enviar <br>o lote</b>  
          <!-- <b style="color:#4A4A4A" class="pt-1 px-0" v-if="item.etapa == 50">Transmitido mas <br> aguardando retorno</b> -->
          <b :style="item.fl_tratado? 'color:#118aca':'color:#D0021B'" class="pt-1 px-0" v-if="item.etapa >= 60 && item.etapa != 80 && item.env_op_tem_erro == 1">Rejeitado pela <br> operadora</b>
          <!-- <b style="color:#FC9D0A" class="pt-1 px-0" v-if="item.etapa >= 70 && item.env_op_tem_erro == 1 && item.capa_lote_doc_id == null">Aceito parcialmente <br> pela operadora</b> -->
          <b style="color:#32B88B" class="pt-1 px-0" v-if="!item.complementar && item.etapa >= 70 && item.etapa != 80 && item.capa_lote_doc_id == null && item.env_op_tem_erro == 0 && (!!dadosCronograma.config && !dadosCronograma.config.FAT_CAPA_LOTE_OBRIGATORIO)">Aceito pela <br> operadora</b>
          <b style="color:#32B88B" class="pt-1 px-0" v-if="!item.complementar && item.etapa >= 70 && item.etapa != 80 && item.capa_lote_doc_id == null && item.env_op_tem_erro == 0 && (!!dadosCronograma.config && dadosCronograma.config.FAT_CAPA_LOTE_OBRIGATORIO)">Aguardando <br> capa de lote</b>
          <b style="color:#32B88B" class="pt-1 px-0" v-if="!item.complementar && item.etapa >= 70 && item.etapa != 80 && item.capa_lote_doc_id != null && item.env_op_tem_erro == 0">Capa de <br> lote obtida</b>
          <b :style="item.fl_tratado? 'color:#118aca':'color:#D0021B'" class="pt-1 px-0" v-if="item.etapa == 80 && (item.env_op_tem_erro == 1 || item.proc_trd_tem_erro == 1) && item.fl_tratado">Erro ignorado<br> pelo usuário</b>
          <v-tooltip
            bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pa-0">
                <v-btn
                  v-if="!item.complementar && (item.etapa >= 70 && (cronogramaConfig && !cronogramaConfig.FAT_ENVIO_OPERADORA) || item.etapa >= 70 && item.capa_lote_doc_id != null)"
                  @click="infoItem(item, 'doc')"  
                  class="py-0 px-0"
                  color="primary" 
                  small 
                  icon>
                  <v-icon small>far fa-folder</v-icon>
                </v-btn>
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              Capa do lote
            </span>
          </v-tooltip>
          <v-btn
            v-if="!item.complementar && (item.proc_trd_tem_erro == 1 || (item.env_op_tem_erro == 1 && item.fl_tratado == 0 && item.etapa >= 40 )) && !item.is_editing && !item.desfazendo_edicoes"
            @click="infoItem(item, 'erro')" 
            class="py-0 px-0" 
            :color="item.fl_tratado? '#118aca':'#D0021B'"
            small 
            icon>
            <v-icon class="pa-0" small>far fa-eye</v-icon>
          </v-btn>
          <v-tooltip
            v-if="!item.complementar && item.env_op_tem_erro == 1 && item.fl_tratado == 1 && !item.desfazendo_edicoes" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pa-0">
                <v-btn
                  @click="infoItem(item, 'erro')" 
                  class="py-0 px-0" 
                  :color="item.fl_tratado? '#118aca':'#D0021B'"
                  small 
                  icon>
                  <v-icon class="pa-0" small>far fa-eye</v-icon>
                </v-btn>
          
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              Erro ignorado pelo usuário
            </span>
          </v-tooltip>
          <!-- EM PROCESSAMENTO -->
          <v-tooltip v-if="!item.complementar && item.etapa >= 25 && item.etapa < 99 && (item.env_op_tem_erro == 0 || fl_tratado == true) && dadosCronograma.config.FAT_ENVIO_OPERADORA"
            bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pa-0">
          <v-progress-circular
            :size="10"
            :width="1"
            color="primary"
            indeterminate
            class="pt-7"
          ></v-progress-circular>
          </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              Em processamento
            </span>
          </v-tooltip>

          <v-tooltip v-if="!item.complementar && (item.is_editing || item.desfazendo_edicoes || (cronogramaConfig && cronogramaConfig.FAT_EDITA_GUIA_VALIDA))" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pa-0">
                <v-btn 
                  v-if="item.is_editing && item.username_editing == userData.UserName && !item.desfazendo_edicoes"
                  class="mt-0 mb-0 ml-1" 
                  color="primary"
                  small 
                  icon 
                  @click="$router.push('/faturamento/cronogramas/dadosdocronograma/detalhesdolote/'+item.id)"
                ><v-icon small>fa-pencil-alt</v-icon>
                </v-btn>
                <!-- EDITAR GUIAS VÁLIDAS -->
                <v-btn 
                  v-if="(cronogramaConfig && cronogramaConfig.FAT_EDITA_GUIA_VALIDA) && !item.username_editing && !item.desfazendo_edicoes && item.etapa == 20 "
                  class="mt-0 mb-0 ml-1" 
                  color="primary"
                  small 
                  icon 
                  @click="editarGuias(item.id)"
                ><v-icon small>fa-pencil-alt</v-icon>
                </v-btn>
                <!-- #EDITAR GUIAS VÁLIDAS -->
                <v-btn 
                  v-else-if="item.is_editing && !item.desfazendo_edicoes && item.username_editing != userData.UserName && (userData.Permissao.faturamento.includes('gestor') || userData.Permissao.faturamento.includes('coordenador'))"
                  class="mt-0 mb-0 ml-0" 
                  color="primary"
                  small 
                  icon 
                  @click="desalocaLote(item)"
                ><v-icon small>fa-key</v-icon>
                </v-btn>
                <v-progress-circular
                  v-else-if="item.is_editing && item.username_editing != userData.UserName"
                  :size="12"
                  :width="1"
                  color="primary"
                  indeterminate
                  class="pt-7"
                ></v-progress-circular>
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              {{item.is_editing? `Lote aberto com ${item.username_editing}.` : ''}} 
              {{item.desfazendo_edicoes? 'Processando o desfazer edições.' : ''}}
              <!-- EDITAR GUIAS VÁLIDAS -->
              {{(cronogramaConfig && cronogramaConfig.FAT_EDITA_GUIA_VALIDA) && !item.is_editing && item.etapa == 20 ? "Editar guias válidas" : ""}}
              <!-- #EDITAR GUIAS VÁLIDAS -->
            </span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.arq_vl_calculado="{ item }">
        
        <v-col v-if="item.arq_vl_informado == item.arq_vl_calculado || item.tipo_guia_descricao == 'Consulta'" class="text-right py-0">
          {{ item.arq_vl_calculado | formatPrice }}
        </v-col>

        <v-col v-if="item.arq_vl_informado != item.arq_vl_calculado  && item.tipo_guia_descricao != 'Consulta'" class="text-right py-0" style="color:#FC9E0D">
          <b>{{ item.arq_vl_calculado | formatPrice }}</b>
        </v-col>

        <v-col v-if="item.arq_vl_informado != item.arq_vl_calculado && item.tipo_guia_descricao != 'Consulta'" class="text-right py-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }" >
              <span  style="color:#FC9E0D" v-bind="attrs" v-on="on" class="pa-0">
                <v-btn small @click="infoItem(item, 'info')" icon>
                  <v-icon small color="orange">fa-exclamation-triangle</v-icon>
                </v-btn>
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Valor calculado diferente do informado</span>
          </v-tooltip>
        </v-col>
      </template>
      <template v-slot:item.arq_vl_conciliado="{ item }">
        <v-col class="text-right py-0">
          <b>{{ item.arq_vl_conciliado | formatPrice}} ({{ item.calc_porcem_conciliado | formatPrice}}%)</b>
        </v-col>
      </template>
      <template v-slot:item.arq_nfs="{ item }">
        <span class="mb-0">{{ joinNotasFiscais(item.arq_nfs) }}</span>
      </template>
      <template v-slot:item.env_op_protocolo="{ item }">
        <div class="d-flex justify-space-between">
          <v-col class="text-center py-0 px-1 pa-0 mt-2">{{ item.env_op_protocolo }}</v-col>
          <v-tooltip v-if="((item.etapa >= 20 && item.proc_trd_tem_erro == 0) || item.etapa >= 40) && !(cronogramaConfig && cronogramaConfig.FAT_ENVIO_OPERADORA) && fechado != 'F' && (item.protocolo_editing_user != userData.UserName && item.protocolo_editing_user != null)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pa-0">
                <v-progress-circular
                  :size="10"
                  :width="1"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              Protocolo em massa aberto com {{item.protocolo_editing_user}}
            </span>
          </v-tooltip>
          <v-btn 
            class="mt-0 mb-0 ml-1" 
            color="primary"
            small 
            icon 
            :disabled="item.is_editing"
            v-if="((item.etapa >= 20 && (!item.proc_trd_tem_erro || (cronogramaConfig && cronogramaConfig.FAT_ACEITA_XML_INVALIDO))) || item.etapa >= 40) && !(cronogramaConfig && cronogramaConfig.FAT_ENVIO_OPERADORA) && fechado != 'F' && (item.protocolo_editing_user == userData.UserName || item.protocolo_editing_user == null) && !item.env_op_tem_erro">
            <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('updateprotocolo')" @click="getProtocolo(item)" small>fa-pencil-alt</v-icon>
            <v-icon v-else @click="userInfo()" small>fa-pencil-alt</v-icon>
          </v-btn>
        </div>
        <v-col v-if="item.env_op_protocolo" class="text-center pa-0">
          {{ item.env_op_dt_protocolo | formatDate }}
        </v-col>
      </template>
    </v-data-table>
    <v-col class="text-center pt-2 pb-0" cols="12">
      <small>* Lotes complementares não serão enviados para a operadora.</small><br>
     <v-pagination class="no-box-shadow" v-model="page" :length="pageCount"></v-pagination>
    </v-col>
    <LotesInfoDlg
      :dialog="showInfo"
      :showClose="(bool) => closeDlg(bool)"
      :items="itemInfo"
      :error="itemError"
      :critica="itemCritica"
      :parameter="cronogramaConfig? cronogramaConfig.FAT_ENVIO_OPERADORA : false"
      :status="fechado"
      :getLotes="()=> getLotes()"
      :getDetalhesCronograma="()=>getDetalhesCronograma()"
      :showValue="showValue"
      :errorType="errorType"
      :userData="userData"
    />
    <ProtocoloDlg
      :dialog="showProt"
      :showClose="()=>showProt=false"
      :items="ItemPro"
      :sendForm="(formData, acao) => saveItem(formData, acao)"
      :isLoteComplementar="false"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import moment from "moment";
moment.locale("pt-BR");
import LotesInfoDlg from './LotesInfoDlg'
import ProtocoloDlg from './ProtocoloDlg'
export default {
  components: {
    LotesInfoDlg,
    ProtocoloDlg
  },
  data() {
    return {
      showProt: false,
      showInfo: false,
      showValor: false,
      itemInfo: {},
      itemError: null,
      itemCritica: null,
      ItemPro: {},
      selectedLotes: [],
      loteData: null,
      pageCount: 1,
      headers: [
        { text: "Arquivo", align: "start", value:  "arq_nome", class: "nowrap_header", sortable: true },
        { text: "Import.", value: "upload_dt", class: "nowrap_header", sortable: true },
        { text: "Estado", value: "etapa", class: "nowrap_header", sortable: false  },
        { text: "Ident. prestador", value: "arq_identificador_prestador", class: "nowrap_header", sortable: false },
        { text: "Núm. lote", value: "arq_numero_lote", class: "nowrap_header", sortable: true },
        { text: "Valor calc. (R$)", value: "arq_vl_calculado", class: "nowrap_header", sortable: true },
        { text: "Vl. Conciliado", value: "arq_vl_conciliado", class: "nowrap_header", sortable: true },
        { text: "Tp. guia", value: "tipo_guia_descricao", class: "nowrap_header", sortable: false },
        { text: "Qtd. guia", value: "arq_qtd_guias", class: "nowrap_header", sortable: true },
        { text: "Nota fiscal", value: "arq_nfs", class: "nowrap_header", sortable: false },
        { text: "Protocolo", value: "env_op_protocolo", class: "nowrap_header", sortable: false },
      ],
      page: 1,
      pagination: {
        limit: 99999,
        offset: 1,
        current_page: 1,
        total: 1
      },
      showValue: null,
      errorType: null,
      selecaoTabela: []
    };
  },
  computed:{
    ...mapState({
      grupoEconomico: state => state.permissions.grupoEconomico,
    })
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch: {
    list: {
      deep: true,
      handler(){
        this.totalPages()
      }
    },
    resetData(val) {
      if (val) {
        this.selectedLotes = []
        this.selected(this.selectedLotes)
        this.selecaoTabela = []
      }
    },
    dadosCronograma: {
      deep: true,
      handler(value){
        if(value.config == null)
          value.config = {};
      }
    },
  },
  methods: {
    closeDlg(bool){
      this.getDetalhesCronograma()
      this.showValue = null
      this.showModal(bool)
    },
    editarGuias(id) {
      let url  = '/faturamento/cronogramas/dadosdocronograma/detalhesdolote/'+id
      this.$router.push(url)
    },
    desalocaLote(lote) {
      let payload = {
        grupo_economico: this.grupoEconomico,
        prestador_id: this.dadosCronograma.prestador_id,
        lote_id: lote.id,
      }
      let paramModal = {
        type: "info",
        title: "Deseja liberar as edição deste lote?",
        message: "As edições serão mantidas e outro usuário poderá editar este lote.",
        callback: () => {
          let obj = {query:[{modulo: 'Faturamento', acao: 'desalocalote', payload}]}
          this.$store.dispatch("request/doRequest",obj).then(resp => {
            if (resp.sucesso)
            // this.$router.push('/faturamento/cronogramas/dadosdocronograma/'+this.dadosCronograma.id)
            this.getLotes()
          })
        },
        btConfirm: { name: "Ok", show: true, },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    showModal() {
      this.showInfo = false
      this.showProt = false
      this.itemInfo = {}
      this.itemCritica = null
      this.itemError = null
      this.showValue = null
      this.errorType = 1
    },
    infoItem(obj, type) {
      this.showValue = null
      this.showValue = type
      this.itemInfo = obj
      if (obj.proc_trd_tem_erro == 1 || obj.env_op_tem_erro == 1) {
        this.getError(obj.id).then((resp)=> this.showInfo = resp)
      } else {
        this.showInfo = true
      }
    },
    totalPages(){
      let total = this.list? parseInt(this.list.length/20) : 0
      total = this.list.length % 20 > 0 ? total++ : total
      this.pagination.total = total == 0 ? 1 : total
      return this.pagination.total
    },
    async getError(id) {
      this.itemCritica = null
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "geterroslote",
          Payload: {
            grupo_economico: this.grupoEconomico,
            lote_id: id,
          }
        }],
      }
      let hasErro = await this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return false;
        }
        
        let json = JSON.parse(response.lote_erros)
        if (response.lote_erros != null) {
          this.itemError = json.Erros? json.Erros : json.Erro ? json.Erro : null
          this.itemCritica = json.criticas? json.criticas : null
          this.errorType = this.itemError != null? 1 : 2
        } else {
          this.itemError = null
          this.itemCritica = null
          this.errorType = 1
        }
        return true
      })
      return hasErro
    }, 
    getProtocolo(item) {
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "getprotocolo",
          Payload: {
            grupo_economico: this.grupoEconomico,
            lote_id: item.id
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.ItemPro = response.protocolo
        this.loteData = item
        this.showProt = true
      })
    },
    joinNotasFiscais(item){
      if(item != null){
        return item.join(', ')
      }
      return ''
    },
    saveItem(formData, acao) {
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: acao,
          Payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: this.dadosCronograma.prestador_id,
            operadora_ans_id: this.dadosCronograma.operadora_ans_id,
            lote_id: this.loteData.id,
            ...formData
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getLotes()
            this.getDetalhesCronograma()
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: 'Cancelar', show: false }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    userInfo() {
      let paramModal = {
        type: "error",
        title: "Atenção!",
        message: "Você não possui permissão para executar esta ação. <br/> Contacte o seu gestor.",
        callback: null,
        btConfirm: { name: "Fechar", show: true },
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    selecionaTodos(selection) {
        if (selection.value) {
          this.selecaoTabela = []
          this.list.forEach(item => {
            this.selecaoTabela.push(item)
          })
          this.selectedLotes = this.selecaoTabela;
        } else {
          this.selecaoTabela = [];
          this.selectedLotes = [];
        }
        this.selected(this.selectedLotes)
      },
     selecaoUnica(selection) {
        if (selection.value) {
            this.selectedLotes.push(selection.item);
        } else {
          let ind = this.selectedLotes.findIndex( item => item == selection.item)
          this.selectedLotes.splice(ind, 1)
        }
        this.selected(this.selectedLotes)

      },
  },
  props: {
    list: Array,
    selected:  Function,
    cronogramaConfig: Object,
    fechado: String,
    resetData: Boolean,
    getLotes: Function,
    getDetalhesCronograma: Function,
    getDocument: Function,
    dadosCronograma: Object,
    userData: Object,
    showLotes: Boolean
  }
};
</script>

<style>

.theme--light.v-data-table.lotesListTable   .v-icon.v-icon {
    font-size: 16px !important;
}
i.v-icon.notranslate.text-icon.material-icons.theme--light.red--text {
  font-size: 12px;
  font-weight: 600;
  font-family: "Catamaran";
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff;
}
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th,
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 5px
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(2),
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(2) {
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th:nth-last-child(2),
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-last-child(2){
    max-width: 80px;
}
</style>